import { ILogger } from '../../interfaces/ILogger';
import { AdapterContext } from '../../model/adapters/adapter-context';
import { ReferenceAdapter } from '../../model/adapters/reference.adapter';
import { ParameterValue } from '../../model/base/parameter-value';
import { LinkedService } from '../../model/linkedservice/linkedservice';
import { SharedModel as Model } from '../../model/sharedmodel';
import { fillParameterValuesForResource } from './parameter-convert.util';

export function linkedServiceReferenceToResource(linkedService: LinkedService | undefined, context: AdapterContext, parameters?: ParameterValue[], loggerService?: ILogger,
    logEventFunc?: (invokedBy: string, loggerService: ILogger) => void): Model.LinkedServiceReference | undefined {
    if (!linkedService) {
        return undefined;
    }
    const result = ReferenceAdapter.toResource(linkedService, context) as Model.LinkedServiceReference;
    if (parameters != null && parameters.length > 0) {
        result.parameters = fillParameterValuesForResource(parameters, context, loggerService, logEventFunc);
    }
    if (context.adapterConfig.linkedServiceNameToExternalConnectionId?.[linkedService.name]) {
        result.referenceName = context.adapterConfig.linkedServiceNameToExternalConnectionId?.[linkedService.name];
    }
    return result;
}
